import { createAction } from '../../../../store.model';
import { ActionType } from '../task-list-dialog.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ToggleSearch {}

export const toggleSearch = createAction<ActionType, ToggleSearch>(
    ActionType.TC__TL__TOGGLE_SEARCH,
);
